// extracted by mini-css-extract-plugin
module.exports = {"toDoCardContainer":"style_toDoCardContainer__25r-s","pagesCont":"style_pagesCont__36YNH","userToDoModal":"style_userToDoModal__3VHzZ","time":"style_time__1nlrd"};